<ng-container>
  <div class="mb-7">
    <app-card-verification-form
      (afterActionVerification)="afterActionVerification($event)"
      (cardNoteChanged)="noteChanged($event)"
      [bodyData]="bodyDataCredit.value"
      [cardNoteValue]="noteValue(EnumCardVerificationSection.CREDIT_CEILING_GRANTED)"
      [dataValue]="dataValue"
      [isLoading]="isLoading"
      [isNotHaveRevision]="detailRegistrationService.checkNotHaveRevision(dataValue.value.credit_ceiling_granted)"
      [isViewOnly]="isViewOnly"
      [sessionKey]="revisionType"
      [withBadgeCheck]="ShowBadge"
      [status]="dataValue.value.credit_ceiling_granted?.status_verified_enum"
      [title]="'Plafon yang Diberikan'"
      [typeSection]="EnumCardVerificationSection.CREDIT_CEILING_GRANTED"
      [type]="EnumCardVerificationForm.DEFAULT"
    />
  </div>
  <div class="mb-7">
    <app-card-verification-form
      (afterActionVerification)="afterActionVerification($event)"
      (cardNoteChanged)="noteChanged($event)"
      [bodyData]="bodyDataSaleTarget.value"
      [cardNoteValue]="noteValue(EnumCardVerificationSection.SALE_TARGET)"
      [dataValue]="dataValue"
      [isLoading]="isLoading"
      [isNotHaveRevision]="detailRegistrationService.checkNotHaveRevision(dataValue.value.sale_target)"
      [isViewOnly]="isViewOnly"
      [withBadgeCheck]="ShowBadge"
      [sessionKey]="revisionType"
      [status]="dataValue.value.sale_target?.status_verified_enum"
      [title]="'Target Penjualan'"
      [typeSection]="EnumCardVerificationSection.SALE_TARGET"
      [type]="EnumCardVerificationForm.DEFAULT"
    />
  </div>
  <div class="mb-7">
    <app-card-verification-form
      (afterActionVerification)="afterActionVerification($event)"
      (cardNoteChanged)="noteChanged($event)"
      [bodyData]="bodyDataBilling.value"
      [cardNoteValue]="noteValue(EnumCardVerificationSection.CREDIT_BILLING)"
      [dataValue]="dataValue"
      [isLoading]="isLoading"
      [isNotHaveRevision]="detailRegistrationService.checkNotHaveRevision(dataValue.value.credit_billing)"
      [withBadgeCheck]="ShowBadge"
      [isViewOnly]="isViewOnly"
      [sessionKey]="revisionType"
      [status]="dataValue.value.credit_billing?.status_verified_enum"
      [title]="'Penagihan Kredit'"
      [typeSection]="EnumCardVerificationSection.CREDIT_BILLING"
      [type]="EnumCardVerificationForm.DEFAULT"
    />
  </div>
</ng-container>
